<template lang="pug">
.container
  br
  h4.header
    span {{ $t('Disconnections')}}
    el-switch.float-end(v-model='intervalDetailSwitch', :active-text='$t("Summary")', :inactive-text='$t("Episodes")')
  hr.header
  el-form.search-form-inline(:inline='true', size="mini")
    el-form-item.label(:label='$t("Period of last:")')
      el-select(v-model='periodSelected', placeholder='Period', @change='calculatePeriod', id="Downtimes-periodSelect")
        el-option.label(:label='$t("custom")', value='custom', id="Downtimes-periodCustom")
        el-option.label(:label='$t("day")', value='day', id="Downtimes-periodDay")
        el-option.label(:label='$t("week")', value='week', id="Downtimes-periodWeek")
        el-option.label(:label='$t("month")', value='month', id="Downtimes-periodMonth")
        el-option.label(:label='$t("year")', value='year', id="Downtimes-periodYear")
    el-form-item.label(v-if='displayCustomForm', :label='$t("Start")')
      el-date-picker(:picker-options="{ firstDayOfWeek: 1 }", id="Downtimes-startDatePicker" v-model='startDate', type="date", :placeholder='$t("Start")', @change='recalculateDatsForCustomPeriod')
    el-form-item.label(v-if='displayCustomForm', :label='$t("End")')
      el-date-picker(:picker-options="{ firstDayOfWeek: 1 }", id="Downtimes-endDatePicker" v-model='endDate', type="date", :placeholder='$t("End")', @change='recalculateDatsForCustomPeriod')
    el-form-item.label(v-if='intervalDetailSwitch && displayCustomForm', :label='$t("Interval")')
      el-select(v-model='intervalMinutes', placeholder='Interval', id="Downtimes-intervalSelect")
        el-option.label(:label='$t("hour")', value='60', id="Downtimes-intervalHour")
        el-option.label(:label='$t("day")', :value='60 * 24', id="Downtimes-intervalDay")
        el-option.label(:label='$t("week")', :value='60 * 24 * 7', id="Downtimes-intervalWeek")
    el-form-item
      el-button(id="Downtimes-loadDataButton", type='primary', @click='loadData') {{ $t(buttonText) }}
    el-form-item.label(v-if='intervalDetailSwitch', :label='$t("Display Only Errors")')
      el-checkbox(id="Downtimes-errorCheckbox", v-model="onlyErrors")
  br
  .section(v-if='intervals.length === 0')
    p {{ $t('No disconnections started in period') }}
  .section(v-if='intervals.length > 0')
    .section(v-if='intervalDetailSwitch')
      .interval.table-header
        .cell.start {{ $t('From') }}
        .cell.end {{ $t('To') }}
        .cell.duration {{ $t('Duration (s)') }}
        .cell.count {{ $t('Number of disconnects in period') }}
      .interval.body(v-for="(interval, index) of intervals", :class="{ hidden: onlyErrors &&  parseInt(interval.downtimecount) === 0, warning: parseInt(interval.downtimecount) > 0 }")
        .cell.start {{ $moment(interval.startUTC).format('YYYY-MM-DD HH:mm:ss') }}
        .cell.end {{ $moment(interval.endUTC).format('YYYY-MM-DD HH:mm:ss') }}
        .cell.duration {{ interval.downtimeseconds ? interval.downtimeseconds : '-' }}
        .cell.count {{ interval.downtimecount > 0 ? interval.downtimecount : '-' }}
    .section(v-if='!intervalDetailSwitch')
      .interval.table-header
        .cell-wider.start {{ $t('Disconnected') }}
        .cell-wider.end {{ $t('Reconnected') }}
        .cell-wider.duration {{ $t('Duration (s)') }}
      .interval.body(v-for="(interval, index) of intervals", :class="{ warning: interval.ongoing }")
        .cell-wider.start {{ $moment(parseInt(interval.startUTC)).format('YYYY-MM-DD HH:mm:ss') }}
        .cell-wider.end {{ !interval.ongoing ? $moment(interval.endUTC).format('YYYY-MM-DD HH:mm:ss') : '-' }}
        .cell-wider.duration
          span {{ interval.downtimeseconds && !interval.ongoing ? humanDuration(interval.downtimeseconds * 1000) : humanDuration(interval.downtimeseconds * 1000) + ' - ' + $t('ongoing') }}
</template>

<script>

import Vue from 'vue'
import textUtils from '../Common/textUtils.mixin'

export default {
  mixins: [textUtils],
  props: ['deviceId'],
  components: {
  },
  async created () {
    await this.loadData()
  },
  updated () {
  },
  watch: {
    intervalDetailSwitch: async function (newVal, oldVal) {
      await this.loadData()
    }
  },
  data () {
    return {
      errors: {
      },
      intervals: [],
      startDate: this.$moment().subtract(1, 'w').format('YYYY-MM-DD'),
      endDate: undefined,
      daysFromStartDate: 7,
      intervalMinutes: 60 * 24,
      onlyErrors: true,
      intervalDetailSwitch: false,
      buttonText: 'Generate',
      periodSelected: 'week',
      displayCustomForm: false
    }
  },
  methods: {
    recalculateDatsForCustomPeriod () {
      this.daysFromStartDate = this.$moment(this.endDate).diff(this.startDate, 'days')
    },
    calculatePeriod (val) {
      if (val === 'custom') {
        this.displayCustomForm = true
        return
      } else {
        this.displayCustomForm = false
      }
      switch (val) {
        case 'day':
          this.startDate = this.$moment().subtract(1, 'd').format('YYYY-MM-DD HH:mm:ss')
          this.daysFromStartDate = this.$moment().diff(this.$moment().subtract(1, 'd'), 'days')
          this.intervalMinutes = 60
          break
        case 'week':
          this.startDate = this.$moment().subtract(1, 'w').format('YYYY-MM-DD')
          this.daysFromStartDate = this.$moment().diff(this.$moment().subtract(1, 'w'), 'days')
          this.intervalMinutes = 60 * 24
          break
        case 'month':
          this.startDate = this.$moment().subtract(30, 'd').format('YYYY-MM-DD')
          this.daysFromStartDate = this.$moment().diff(this.$moment().subtract(30, 'd'), 'days')
          this.intervalMinutes = 60 * 24
          break
        case 'year':
          this.startDate = this.$moment().subtract(1, 'y').format('YYYY-MM-DD')
          this.daysFromStartDate = this.$moment().diff(this.$moment().subtract(1, 'y'), 'days')
          this.intervalMinutes = 60 * 24 * 7
          break
        default:
          break
      }
    },
    async __getIntervals () {
      await Vue.axios
        .post(`Downtime/getIntervalsForDevice`,
          {
            deviceId: this.deviceId,
            startDate: this.startDate,
            daysFromStartDate: this.daysFromStartDate,
            intervalMinutes: this.intervalMinutes
          })
        .then(response => {
          this.intervals = response.data
        })
    },
    async __getDetails () {
      await Vue.axios
        .post(`Downtime/getDowntimes`,
          {
            entity: 'Device',
            entityId: this.deviceId,
            startTimestamp: this.$moment(this.startDate).unix() * 1000,
            daysFromStartDate: this.daysFromStartDate
          }
        )
        .then(response => {
          this.intervals = response.data
        })
    },
    async loadData () {
      this.intervals = []
      this.buttonText = 'loading data...'
      if (this.intervalDetailSwitch) {
        this.__getIntervals()
      } else {
        this.__getDetails()
      }
      this.buttonText = 'Generate'
    }
  },
  computed: {
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
.header {
  display: flex;
  justify-content: space-between;
}
.search-form-inline {
  .label {
    font-size: $--font-size-base;
    .el-form-item__label {
      font-size: $--font-size-base;
    }
  }
}
.interval {
  &.hidden {
    display: none;
  }
  &.warning {
    background-color: rgba($--color-danger, 0.2);
  }
  &.table-header {
    margin-bottom: 10px;
    padding: 5px 0px 5px 0px;
    border-top: $--border-light;
    border-bottom: $--border-light;
  }
  &.body {
    margin-bottom: 10px;
    color: $--color-text-secondary;
  }
  display: flex;
  font-size: $--font-size-base;
  .cell {
    width: 25%
  }
  .cell-wider {
    width: 33%;
    border: 0px dotted pink;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Device/Downtimes.vue